import { type ReactNode } from 'react';
import clsx from 'clsx';

import styles from '@web/molecules/Widget/atoms/WidgetHeaderSection/WidgetHeaderSection.module.scss';

interface Props {
    children: ReactNode;
    noBorderBottom?: boolean;
}

export const WidgetHeaderSection = ({ children, noBorderBottom }: Props) => (
    <div
        className={clsx(
            styles['WidgetHeaderSection'],
            noBorderBottom && styles['WidgetHeaderSection--no-border-bottom'],
        )}
    >
        {children}
    </div>
);
